'use client';
import React from 'react';
import { WeatherData } from '@/lib/types';
import ForecastTimeline from '@/components/ForecastTimeline';

interface Props {
  weatherData: WeatherData;
}

export default function MeteoContent({ weatherData }: Props) {
  const { metar } = weatherData;

  return (
    <div className="h-full page-scroll px-3 py-3">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-lg font-700 text-foreground">Météo prévisionnelle — CYRC</h2>
          <p className="text-sm text-muted-foreground">
            Chicoutimi / Saint-Honoré · METAR {metar.time}
          </p>
        </div>
        <div className="flex items-center gap-2">
          <span className={`text-xs font-600 px-2 py-1 rounded-full ${
            metar.flightCategory === 'VFR' ? 'bg-green-100 text-vfr' :
            metar.flightCategory === 'MVFR' ? 'bg-blue-100 text-mvfr' :
            metar.flightCategory === 'IFR' ? 'bg-red-100 text-ifr' :
            'bg-purple-100 text-lifr'
          }`}>
            {metar.flightCategory}
          </span>
          <span className="text-xs text-muted-foreground">
            Mis à jour il y a {metar.ageMinutes} min
          </span>
        </div>
      </div>

      <ForecastTimeline weatherData={weatherData} />
    </div>
  );
}